// src/components/FullWidthCard.js

import React from "react";
import JoinWaitlistButton from "./JoinWaitlistButton";

function FullWidthCard() {
  return (
    <div className="container mx-auto py-24 px-6">
      <div className="relative overflow-hidden bg-blue-600 rounded-[3rem] p-12 md:p-20 shadow-2xl shadow-blue-500/20 text-center">
        {/* Decorative Background Glows */}
        <div className="absolute top-0 left-0 w-64 h-64 bg-white/10 blur-[100px] rounded-full -ml-32 -mt-32" />
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-black/10 blur-[100px] rounded-full -mr-32 -mb-32" />

        <div className="relative z-10 max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-black text-white mb-8 leading-tight tracking-tight">
            <span className="opacity-80">BRACCET</span> is launching very soon, and we can't wait for you to try it.
          </h2>
          <p className="text-blue-100 text-lg md:text-xl font-medium mb-12 max-w-2xl mx-auto">
            Be part of the exclusive group that redefines viral collaboration. Secure your spot on the waitlist today.
          </p>
          <div className="flex justify-center">
            <JoinWaitlistButton />
          </div>
        </div>
      </div>
    </div>
  );
}

export default FullWidthCard;
